import { ThemeOptions } from '@mui/material/styles/createTheme';
import { alpha } from '@mui/material';

export const MuiMenuItemStyle = {
  styleOverrides: {
    root: ({ theme }: { theme: ThemeOptions }) => ({
      padding: theme.spacing != null && typeof theme.spacing === 'function' ? theme?.spacing(1.5) : '12px 12px',
      '&.Mui-selected': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        color: theme?.palette?.primary?.main,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        backgroundColor: theme?.palette?.white?.main,
        fontWeight: 'bold',
      },
      '&:hover': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        backgroundColor: alpha(theme?.palette?.primary?.light, 0.18),
      },
    }),
  },
};
